import { useParams } from 'react-router-dom';

import { PaginatedTable, useTableDataQuery } from '@/modules/common';
import { FiltersChangeType } from '@/modules/events/hooks';
import { EventSms } from '@/modules/events/types';

import { getSmsHistoryColumns } from './columns';
import { TableFilters } from './components';

export const SmsHistoryTab = () => {
  const params = useParams<{ id: string }>();

  const {
    data: smsHistoryData,
    isFetching,
    filters,
    setFilters: filtersChange,
    ...tableProps
  } = useTableDataQuery<EventSms>({
    url: `/events/${params.id}/sms-history`,
  });

  const columns = getSmsHistoryColumns();

  return (
    <div className="flex flex-col gap-4">
      <p className="font-semibold text-lg">SMS Table</p>
      <div className="flex flex-col gap-4">
        <PaginatedTable<EventSms>
          pinEnabled
          data={smsHistoryData}
          columns={columns}
          searchable
          totalCountLabel="SMS"
          searchPlaceholder="Search by phone number"
          emptyTitle="No sms yet"
          emptyDescription=""
          sizeStyleProperty="minWidth"
          isLoading={isFetching}
          tableCellClassName="px-2 py-1"
          tableFilterClassName="flex-wrap justify-start mb-4"
          {...tableProps}
        >
          <TableFilters
            filters={filters}
            onFilters={filtersChange as FiltersChangeType}
          />
        </PaginatedTable>
      </div>
    </div>
  );
};
